function flattenLesson(lessonsProgress, composite = []) {
  const { lessons } = lessonsProgress;
  const flatten = { lessons: {} };
  if (lessons) {
    Object.keys(lessons).forEach(lessonID => {
      flatten.lessons[lessonID] = {
        type: lessons[lessonID]['lesson-type'],
        videoWatchedSeconds: lessons[lessonID]['video-watched-seconds'],
        videoWatchedPercentage: lessons[lessonID]['video-watched-percent'],
        completed: lessons[lessonID].completed,
        updatedAt: lessons[lessonID]['updated-at'],
        id: lessonID,
        composite,
      };
    });
  }
  return flatten;
}

function flattenCourses(coursesProgress, composite = []) {
  const { courses } = coursesProgress;
  const flatten = { courses: {}, lessons: {} };
  if (courses) {
    Object.keys(courses).forEach(courseID => {
      const course = courses[courseID];
      const {
        type,
        'current-lesson': currentLesson = null,
        completed,
        'lessons-completed': lessonsCompleted,
        'lessons-completed-percent': lessonsCompletedPercent,
        'lessons-total': lessonsTotal,
      } = course;
      flatten.courses[courseID] = {
        type,
        composite,
        currentLesson,
        id: courseID,
        completed,
        lessonsCompleted,
        lessonsCompletedPercent,
        lessonsTotal,
      };
      const flatLesson = flattenLesson(course, [...composite, courseID]);
      flatten.lessons = {
        ...flatten.lessons,
        ...flatLesson.lessons,
      };
    });
  }
  return flatten;
}

function flattenPlaylists(playlistsProgress, composite = []) {
  const { playlists } = playlistsProgress;
  const flatten = { playlists: {}, courses: {}, lessons: {} };
  if (playlists) {
    Object.keys(playlists).forEach(playlistID => {
      flatten.playlists[playlistID] = {
        composite,
        currentCourse: playlists[playlistID]['current-course'] || null,
      };
      const flatCourse = flattenCourses(playlists[playlistID], [...composite, playlistID]);
      flatten.courses = {
        ...flatten.courses,
        ...flatCourse.courses,
      };
      flatten.lessons = {
        ...flatten.lessons,
        ...flatCourse.lessons,
      };
    });
  }
  return flatten;
}

function addPathsToFlattened(paths, flattened) {
  const flatten = { ...flattened };
  Object.keys(paths).forEach(pathID => {
    const pathObj = paths[pathID];
    const { instrument, playlists, style } = pathObj;
    flatten.paths[pathID] = {
      style,
      instrument,
      playlists,
      currentPlaylist: pathObj['current-playlist'] || null,
    };
    const flatPlaylist = flattenPlaylists(pathObj, [pathID]);
    flatten.playlists = { ...flatten.playlists, ...flatPlaylist.playlists };
    flatten.courses = { ...flatten.courses, ...flatPlaylist.courses };
    flatten.lessons = { ...flatten.lessons, ...flatPlaylist.lessons };
  });
  return flatten;
}

function flattenPaths(pathsProgress, state = {}) {
  const progressPaths = pathsProgress.paths || null;
  const { lessons, courses, playlists, paths } = state;
  const startPaths = paths ? JSON.parse(JSON.stringify(paths)) : {};
  let flatten = {
    paths: startPaths,
    playlists: playlists || {},
    courses: courses || {},
    lessons: lessons || {},
  };
  flatten.currentPath = pathsProgress['current-path'] || null;
  if (progressPaths) {
    flatten = addPathsToFlattened(progressPaths, flatten);
  }
  return flatten;
}

export { flattenLesson, flattenCourses, flattenPlaylists, flattenPaths };
